export enum TrainingState {
  LOADING = "LOADING",
  DIRTY = "DIRTY",
  UNTRAINED = "UNTRAINED",
  UNPUBLISHED = "UNPUBLISHED",
  TRAINING = "TRAINING",
  TRAINED = "TRAINED",
  ERROR = "ERROR", // This is new and not yet implemented.
  FAILED = "FAILED",
  PUBLISHING = "PUBLISHING",
  PUBLISHED = "PUBLISHED"
}

export interface LUISEntity {
  id: string;
  name: string;
  typeId: string;
  readableType: string;
  roles: any[];
}

export interface LUISIntent {
  id: string;
  name: string;
  typeId: number;
  readableType: string;
}
export interface LUISLabelingEntityPrediction {
  // This one is used in conversion
  entityName: string;
  startCharIndex: number;
  endCharIndex: number;
}
export interface LUISExampleEntityPrediction {
  entityName: string;
  startTokenIndex: number;
  endTokenIndex: number;
}

export interface LUISExample {
  id: number;
  text: string;
  intentLabel: string;
  tokenizedText: string[];
  entityLabels: { entityName: string; startTokenIndex: number; endTokenIndex: number }[];
  intentPredictions: { name: string; score: number }[];
  entityPredictions: LUISExampleEntityPrediction[];
  multiIntentPredictions?: any;
}

export interface Intent {
  name: string;
}

export interface Entity {
  name: string;
  children: string[];
  roles: string[];
}

export interface Utterance {
  text: string;
  intent: string;
  entities: LabeledEntity[];
}

export interface LabeledEntity {
  entity: string;
  startPos: number;
  endPos: number;
}

export interface NLPModelInterface {
  luis_schema_version: string;
  versionId: string;
  name: string;
  desc?: string;
  culture: string;
  tokenizerVersion: string;
  intents: Intent[];
  entities: Entity[];
  utterances: Utterance;
}

export interface NLPResponseIntent {
  intent: string;
  score: number;
}
export interface NLPResponse {
  query: string;
  topScoringIntent?: NLPResponseIntent;
  intents: NLPResponseIntent[];
  entities: NLPResponseEntity[];
  sentimentAnalysis?: {
    label: string;
    score: number;
  };
}
export interface NLPResponseEntity {
  entity: string; // Query in string
  type: string; // Name of entity
  startIndex: number; // Start index of entity in query
  endIndex: number; // End index of entity in query
  score: number; // Confidence score of entity extraction
  resolution?: any; // Resolution of entity
}

// NLP Comparison Types

export interface NLPComparisonRequest {
  luisAppId: string;
  luisVersion: string;
  cluProjectName: string;
  cluDeploymentName: string;
}

export interface NLPComparisonPrediction {
  topIntent: string;
  topScore: number;
}

export enum NLPComparisonMatchStatus {
  PENDING = "PENDING",
  BOTH_CORRECT = "BOTH_CORRECT",
  LUIS_ONLY = "LUIS_ONLY",
  CLU_ONLY = "CLU_ONLY",
  BOTH_WRONG = "BOTH_WRONG"
}

export interface NLPComparisonUtterance {
  text: string;
  labeledIntent: string;
  luisResult?: NLPComparisonPrediction;
  cluResult?: NLPComparisonPrediction;
  match: NLPComparisonMatchStatus;
}

export enum NLPComparisonJobStatus {
  LOADING_UTTERANCES = "LOADING_UTTERANCES",
  RUNNING_PREDICTIONS = "RUNNING_PREDICTIONS",
  COMPLETE = "COMPLETE",
  ERROR = "ERROR"
}

export interface NLPComparisonSummary {
  total: number;
  bothCorrect: number;
  luisOnly: number;
  cluOnly: number;
  bothWrong: number;
  pending: number;
}

export interface NLPComparisonJobState {
  id: string;
  status: NLPComparisonJobStatus;
  progress: number;
  totalUtterances: number;
  completedUtterances: number;
  results: NLPComparisonUtterance[];
  summary?: NLPComparisonSummary;
  error?: string;
}
